import * as types from './types';

export interface IShowMSRP {
  type: types.TOGGLE_MSRP;
  showOnlyMSRP: boolean;
}

export const toggleMSRP = () => {
  return {
    type: types.TOGGLE_MSRP
  };
};

export default {
  toggleMSRP
};
